import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Dialog from './Dialog';
import ContainerRender from 'rc-util/es/ContainerRender';
import Portal from 'rc-util/es/Portal';
var IS_REACT_16 = ('createPortal' in ReactDOM);
var DialogWrap = function (_React$Component) {
  _inherits(DialogWrap, _React$Component);
  function DialogWrap() {
    _classCallCheck(this, DialogWrap);
    var _this = _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    _this.saveDialog = function (node) {
      _this._component = node;
    };
    _this.getComponent = function () {
      var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return React.createElement(Dialog, _extends({
        ref: _this.saveDialog
      }, _this.props, extra, {
        key: "dialog"
      }));
    };
    // fix issue #10656
    /*
    * Custom container should not be return, because in the Portal component, it will remove the
    * return container element here, if the custom container is the only child of it's component,
    * like issue #10656, It will has a conflict with removeChild method in react-dom.
    * So here should add a child (div element) to custom container.
    * */
    _this.getContainer = function () {
      var container = document.createElement('div');
      if (_this.props.getContainer) {
        _this.props.getContainer().appendChild(container);
      } else {
        document.body.appendChild(container);
      }
      return container;
    };
    return _this;
  }
  DialogWrap.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref) {
    var visible = _ref.visible;
    return !!(this.props.visible || visible);
  };
  DialogWrap.prototype.componentWillUnmount = function componentWillUnmount() {
    if (IS_REACT_16) {
      return;
    }
    if (this.props.visible) {
      this.renderComponent({
        afterClose: this.removeContainer,
        onClose: function onClose() {},
        visible: false
      });
    } else {
      this.removeContainer();
    }
  };
  DialogWrap.prototype.render = function render() {
    var _this2 = this;
    var visible = this.props.visible;
    var portal = null;
    if (!IS_REACT_16) {
      return React.createElement(ContainerRender, {
        parent: this,
        visible: visible,
        autoDestroy: false,
        getComponent: this.getComponent,
        getContainer: this.getContainer
      }, function (_ref2) {
        var renderComponent = _ref2.renderComponent,
          removeContainer = _ref2.removeContainer;
        _this2.renderComponent = renderComponent;
        _this2.removeContainer = removeContainer;
        return null;
      });
    }
    if (visible || this._component) {
      portal = React.createElement(Portal, {
        getContainer: this.getContainer
      }, this.getComponent());
    }
    return portal;
  };
  return DialogWrap;
}(React.Component);
DialogWrap.defaultProps = {
  visible: false
};
export default DialogWrap;